<mat-form-field class="sections-chip-list">
  <div
    class="h-100 w-100 d-flex align-items-center justify-content-between gap-0"
  >
    <input
      matInput
      placeholder="Search emails (min 3 chars)..."
      #userInput
      autocomplete="off"
      [formControl]="userCtrl"
      [matAutocomplete]="auto"
      class="input-style"
    />
    <span
      *ngIf="isLoadingUsers"
      class="spinner-border spinner-border-chat ms-2 me-1"
    ></span>
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selected($event)"
    [displayWith]="displayFn"
    class="testClass6"
  >
    <ng-container *ngIf="allUsersList && allUsersList.length > 0; else noUsers">
      <mat-option
        *ngFor="let user of allUsersList"
        [value]="user"
        [disabled]="checkOpptionSelected(user)"
      >
        {{ user.user_email }}
      </mat-option>
    </ng-container>
    <ng-template #noUsers>
      <ng-container *ngIf="showNoUsersFound()">
        <mat-option disabled>No users found</mat-option>
      </ng-container>
    </ng-template>
  </mat-autocomplete>
</mat-form-field>
